import { HfsSettingsActionEnum } from 'fleet-data-model';
import { UpdateMissionTypeEnum } from '~/domain/roboticmower-details/models/UpdateMissionTypeEnum';

const mowerOperationsTimeouts = new Map<string, number>();
mowerOperationsTimeouts.set(HfsSettingsActionEnum.MOWER_CUTTING_HEIGHT, 45_000);
mowerOperationsTimeouts.set(HfsSettingsActionEnum.MOWER_SCHEDULE, 45_000);
mowerOperationsTimeouts.set(UpdateMissionTypeEnum.UpdateMissionEnabled, 45_000);
mowerOperationsTimeouts.set(UpdateMissionTypeEnum.UpdateMissionAugmentByVision, 45_000);
mowerOperationsTimeouts.set(UpdateMissionTypeEnum.UpdateMissionBehaviour, 30_000);
mowerOperationsTimeouts.set(UpdateMissionTypeEnum.UpdateMissionCuttingHeight, 45_000);
mowerOperationsTimeouts.set(UpdateMissionTypeEnum.UpdateMissionSchedule, 45_000);

export const getHfsOperationPayloadMemoTimeout = (hfsActionId: string) => {
  return mowerOperationsTimeouts.get(hfsActionId) ?? 30_000;
};
